import MakeAppointmentHub from './MakeAppointmentHub'
export default MakeAppointmentHub